import type { ITblMSogoServiceData } from "@/models/TblMSogoService";
import { TblMSogoService } from "@/models/TblMSogoService";
import MyCommon from "@/Js/MyCommon";
import MyServiceDatabase from "@/DB/MyServiceDatabase";
//import type {MyServiceDatabase} from "@/DB/MyServiceDatabase";
import { DetailData, WeekData } from "@/models/ServiceUsageTable";
import { JissekiData } from "@/models/ServiceUsageJissekiTable";
import alasql from "alasql";
import axios from "axios";
import CompanyService from "@/Js/CompanyService";

export class TblMSogoServiceService {
    myCommon: MyCommon;
    companyService;
    db;
    services: TblMSogoService[];
    constructor() {
        this.myCommon = new MyCommon();
        this.db = MyServiceDatabase;
        this.services = [new TblMSogoService];
        this.companyService = CompanyService;
        axios.defaults.headers.common['Authorization'] = `Bearer ${sessionStorage.getItem('token')}`; //Tokenの場合
    }

    async getService(
        serviceType: string,
        serviceCode: string,
        dtmTeikyoTuki: Date | null,
        hokenCode: string
    ): Promise<TblMSogoService | null> {
        try {

            if (dtmTeikyoTuki == null) {
                dtmTeikyoTuki = this.myCommon.getFirstMonth(new Date()) as Date;
            }

            const teikyoTuki = this.myCommon.myformat(dtmTeikyoTuki, 'yyyyMM')

            const item = this.services.find(item =>
                item.serviceType === serviceType
                && item.serviceCode === serviceCode
                && item.hokenCode === hokenCode
                && (item?.kaisibi ?? '') <= teikyoTuki
                && (item?.syuryobi ?? '') >= teikyoTuki
            );

            if (!item) {
                return null
            }

            return item;
        } catch (error) {
            console.error("Error in getService:", error);
            return null; // エラー時は null を返す
        }
    }

    async getServices(
        serviceType: string,
        dtmTeikyoTuki: Date | null,
        hokenCode: string
    ): Promise<TblMSogoService[] | null> {
        try {

            if (dtmTeikyoTuki == null) {
                dtmTeikyoTuki = this.myCommon.getFirstMonth(new Date()) as Date;
            }

            const teikyoTuki = this.myCommon.myformat(dtmTeikyoTuki, 'yyyyMM');

            const item = this.services.filter(item =>
                item.serviceType === serviceType
                && item.hokenCode === hokenCode
                && (item?.kaisibi ?? '') <= teikyoTuki
                && (item?.syuryobi ?? '') >= teikyoTuki
            );

            if (!item) {
                return null
            }

            return item;

        } catch (error) {
            console.error("Error in getService:", error);
            return null; // エラー時は null を返す
        }
    }

    async getMonthServices(
        dtmTeikyoTuki: Date | null
    ) {
        try {

            if (dtmTeikyoTuki == null) {
                dtmTeikyoTuki = this.myCommon.getFirstMonth(new Date()) as Date;
            }

            const strDate = `${dtmTeikyoTuki.getFullYear()}-${dtmTeikyoTuki.getMonth() + 1}-01`;

            const endpoint: string = `${import.meta.env.VITE_LOCAL_API_TARGET
                }/localapi/MSogoService/GetListsByMonth/${this.companyService.companyCode}/${this.companyService.officeCode}/${this.companyService.serviceType}/${strDate}`;

            const token = sessionStorage.getItem('token');
            const response = await axios.get(endpoint, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            this.services = [new TblMSogoService];
            if (response.status === 200) {

                this.services = response.data.map(
                    (item: ITblMSogoServiceData) => {
                        return new TblMSogoService({
                            ...item,
                            isSelect: false,
                        });
                    }
                );

            }

        } catch (error) {
            console.error("Error in getService:", error);
            return null; // エラー時は null を返す
        }
    }


    async getYoteiServices(
        dtmTeikyoTuki: Date | null,
        detailDatas: DetailData[]
    ): Promise<any[] | null> {
        try {
            if (dtmTeikyoTuki == null) {
                dtmTeikyoTuki = this.myCommon.getFirstMonth(new Date());
            }

            const matchingRecords = await this.services;

            // 📅 各データの日付フォーマット
            const formattedDetails = detailDatas.map((data) => ({
                ...data,
                teikyoMonthFormatted: this.myCommon.myformat(dtmTeikyoTuki, 'yyyyMM'),
            }));


            if (!matchingRecords || matchingRecords.length === 0) {
                return null;
            }

            // 🔄 JOIN処理（AlaSQLでデータを結合）
            const query = `
                SELECT 
                    D.*,
                    S.serviceName as serviceRyaku,
                    S.goseiKbn
                FROM ? AS D
                JOIN ? AS S
                ON D.serviceType = S.serviceType
                AND D.serviceCode = S.serviceCode
                AND D.hokensya = S.hokenCode
                AND D.teikyoMonthFormatted >= S.kaisibi
                AND (S.syuryobi = '999999' OR D.teikyoMonthFormatted <= S.syuryobi)
                `;

            const result = alasql(query, [formattedDetails, matchingRecords]);

            // 📝 結果を返却
            return result.map((row: any) => ({
                ...row,
            }));
        } catch (error) {
            console.error('Error in getYoteiServices:', error);
            return null;
        }
    }

    async getJissekiServices(
        dtmTeikyoTuki: Date | null,
        jissekiDatas: JissekiData[]
    ): Promise<any[] | null> {
        try {
            if (dtmTeikyoTuki == null) {
                dtmTeikyoTuki = this.myCommon.getFirstMonth(new Date());
            }

            const matchingRecords = await this.services;

            // 📅 各データの日付フォーマット
            const formattedDetails = jissekiDatas.map((data) => ({
                ...data,
                teikyoMonthFormatted: this.myCommon.myformat(dtmTeikyoTuki, 'yyyyMM'),
            }));

            if (!matchingRecords || matchingRecords.length === 0) {
                return null;
            }

            // 🔄 JOIN処理（AlaSQLでデータを結合）
            const query = `
                    SELECT 
                        D.*,
                        S.serviceName as serviceRyaku,
                        S.goseiKbn
                    FROM ? AS D
                    JOIN ? AS S
                    ON D.serviceType = S.serviceType
                    AND D.serviceCode = S.serviceCode
                    AND D.hokensya = S.hokenCode
                    AND D.teikyoMonthFormatted >= S.kaisibi
                    AND (S.syuryobi = '999999' OR D.teikyoMonthFormatted <= S.syuryobi)
                    `;

            const result = alasql(query, [formattedDetails, matchingRecords]);

            // 📝 結果を返却
            return result.map((row: any) => ({
                ...row,
            }));
        } catch (error) {
            console.error('Error in getYoteiServices:', error);
            return null;
        }
    }

    async getWeekServices(
        dtmTeikyoTuki: Date | null,
        weekDatas: WeekData[]
    ): Promise<any[] | null> {
        try {
            if (dtmTeikyoTuki == null) {
                dtmTeikyoTuki = this.myCommon.getFirstMonth(new Date());
            }

            const matchingRecords = await this.services;

            // 📅 各データの日付フォーマット
            const formattedDetails = weekDatas.map((data) => ({
                ...data,
                teikyoMonthFormatted: this.myCommon.myformat(dtmTeikyoTuki, 'yyyyMM'),
            }));


            if (!matchingRecords || matchingRecords.length === 0) {
                return null;
            }

            // 🔄 JOIN処理（AlaSQLでデータを結合）
            const query = `
                SELECT 
                    D.*,
                    S.serviceName as serviceRyaku,
                    S.goseiKbn
                FROM ? AS D
                JOIN ? AS S
                ON D.serviceType = S.serviceType
                AND D.serviceCode = S.serviceCode
                AND D.hokensya = S.hokenCode
                AND D.teikyoMonthFormatted >= S.kaisibi
                AND (S.syuryobi = '999999' OR D.teikyoMonthFormatted <= S.syuryobi)
                `;

            const result = alasql(query, [formattedDetails, matchingRecords]);

            // 📝 結果を返却
            return result.map((row: any) => ({
                ...row,
            }));
        } catch (error) {
            console.error('Error in getYoteiServices:', error);
            return null;
        }
    }


    async deleteFromTblMService(
        serviceType: string,
        dtmDate: string,
        hokenCode: string
    ): Promise<number> {
        const count: number = await this.db.tblMService
            .where("serviceType")
            .equals(String(serviceType))
            .where("hokenCode")
            .equals(String(hokenCode))
            .and(
                (item: TblMSogoService) =>
                    String(item?.kaisibi ?? "") <= String(dtmDate) &&
                    String(item?.syuryobi ?? "") >= String(dtmDate)
            )
            .delete();

        return count;
    }

    processAndGroupBy(serviceNames: TblMSogoService[]) {
        // すべてのサービス名を分割してフラット化
        const splitParts = serviceNames
            .flatMap((name) => name.serviceName?.split("・")) // 「・」で分割
            .map((part) => {
                // 「算」以降を削除
                const index = part?.indexOf("算") ?? 0;
                return index !== -1 ? part?.substring(0, index + 1).trim() : part?.trim();
            })
            .filter((part) => part?.length ?? 0 > 0); // 空文字を除外

        // 分割結果をグループ化

        //reduce は、JavaScript と TypeScript における配列メソッドの一つで、
        //配列を1つの累積値に変換するために使用されます。累積処理を行いたいときに非常に便利です。

        const grouped = splitParts.reduce((acc: Record<string, number>, part) => {
            if (part) {
                acc[part] = (acc[part] || 0) + 1;
            }
            return acc;
        }, {});

        return grouped;
    }

}